import { h } from "vue";

const LazyYoutube = {
  name: "LazyYoutube",
  props: {
    src: String,
    url: String,
    aspectRatio: { type: String, default: "16:9" }
  },
  setup(props) {
    return () => {
      const raw = props.src || props.url || "";
      let embed = raw;
      const match = raw.match(
        /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([A-Za-z0-9_-]+)/
      );
      if (match) {
        embed = `https://www.youtube.com/embed/${match[1]}`;
      }
      return h("div", { class: "embed-responsive embed-responsive-16by9" }, [
        h("iframe", {
          class: "embed-responsive-item",
          src: embed,
          allow:
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: true,
          frameborder: "0"
        })
      ]);
    };
  }
};

export default {
  install(app) {
    app.component("LazyYoutube", LazyYoutube);
    app.component("lazy-youtube", LazyYoutube);
    app.component("LazyTube", LazyYoutube);
  }
};
